import { useContext } from 'react';
import { InjectableDependencyOverrides } from 'core/context';

export const useInjectable = (key, defaultValue) => {
  const overrides = useContext(InjectableDependencyOverrides);
  return overrides[key] || defaultValue;
};
